import { render, staticRenderFns } from "./UserProfileView.vue?vue&type=template&id=1ffb7a16&"
import script from "./UserProfileView.vue?vue&type=script&lang=ts&"
export * from "./UserProfileView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports